// ─────────────────────────────────────────────────────────────────────────────────────────────────
// ⚠️  THIS FILE COMPILES THE ARTIFACT FOR THE ENTIRE TOTEM FLEET.
//
// `ionic build --prod` → `www/` → Plesk (Destino A) and `app-cicerone.zip` (Destino B, one zip for
// every totem). Changing a literal here reaches every device, so `environment.spec.ts` asserts them
// one by one: touching one turns the suite red on purpose, and the change arrives with its ticket.
// ─────────────────────────────────────────────────────────────────────────────────────────────────

import { KioskEnvironment } from './environment.model';

export const environment: KioskEnvironment = {
  production: true,

  // CMS root, not `/api` — `/storage/**` and `/langs/*.svg` hang off this too.
  apiUrlBase: 'https://cicerone.cms-iurban.com',

  // Asistente: rutas recomendadas del planificador, el mismo host que lee la web (HRS-2958).
  assistantUrlBase: 'https://v3.gpt.cms-iurban.com',

  // Old CMS: dictionaries (`/langs/`) and OSRM. ⚠️ `/langs/` has an Origin allowlist and production
  // is inside it; repointing this host breaks the fleet's translations. Measured 30-jul-2026.
  legacyCmsUrlBase: 'https://cms-iurban.com',

  // Berlin route used as a ping. Absolute on purpose: it must measure real internet.
  connectivityProbeUrl:
    'https://cms-iurban.com/osrm_foot/route/v1/driving/13.388860,52.517037;13.397634,52.529407?overview=false',

  publicWebUrl: 'https://ciceroneweb.com',
  publicWebTenantUrlTemplate: 'https://TENANT_NAME_INDEX.ciceroneweb.com',

  // ⚠️⚠️ CUIDADO: PRODUCTION IS USING **PRE** ⚠️⚠️
  // Visitor selfies go to preproduction, not to the CMS above. Live code, not a leftover
  // (rest.service.ts:120 ← selfie.page.ts:329). Not repointed here: own ticket.
  selfieQrUrl: 'https://pre.ciceroneweb.com/api/enviar-qr',

  // Dead at runtime. Left as it ships so the fleet's bundle stays byte-equivalent.
  socketUrl: 'wss://node.ciceroneweb.com',

  sentryDsn:
    'https://2c68eab6f56fa125a9bbe9d3b2cf4e3e@o4510035615416320.ingest.de.sentry.io/4510062010368080',
};